import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15px"
    height="15px"
    viewBox="0 0 15 15"
    space="preserve"
    style={{
      name: 'style',
      value: 'enable-background:new 0 0 15 15;'
    }}>
    <path d="M7.5,0C3.4,0,0,3.4,0,7.5S3.4,15,7.5,15S15,11.6,15,7.5S11.6,0,7.5,0z M8.2,11.2H6.8V9.8h1.5V11.2z M8.2,8.2H6.8V3.8h1.5\n\tV8.2z" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/error.es6.js